<p-tree [value]="TreeNodes" [selectionMode]="selectionMode" [(selection)]="selected" [style]="style" [filter]="filter"
  [filterPlaceholder]="filterPlaceholder" [scrollHeight]="scrollHeight" [filterBy]="filterBy"
  (onNodeSelect)="onNodeSelect($event)" [styleClass]="treeStyleClass">
  <ng-template let-node pTemplate="default">
    <span *ngIf="!isNodeInEdit(node)" (dblclick)="onDoubleClick($event,node)"
      [ngStyle]="treeItemLabelStyle">{{node.label}}{{showDocCount?' ('+ node.data?.docCount +')':''}}</span>
    <p-autoComplete *ngIf="isNodeInEdit(node)" [(ngModel)]="selectedFolderName" name="folderNameEditor"
      panelStyleClass="disable-option ui-panel-blockScroll" styleClass="full-width" [forceSelection]="forceSelection"
      [suggestions]="filteredSuggestions" (completeMethod)="onFilterSuggestion($event)" field="label"
      (onBlur)="onConfirmInput($event)" (onShow)="isAutoCompletePanelOpen=true;" appendTo="body"
      [inputId]="randomAutoCompleteId" (onHide)="isAutoCompletePanelOpen=false;" (onKeyUp)="onkeyup($event)"
      [disabled]="disabled" (onSelect)="onSelectInput($event)">
      <ng-template pTemplate="item" let-option let-index="index">
        <span [ngClass]="{'disabled': option.disabled}" style="display: inline-block;width:100%;"
          (click)="onItemClick($event,option)">{{option.label}}</span>
      </ng-template>
    </p-autoComplete>
    <span class="toolbar" *ngIf="!readOnly&&!disabled">
      <span class="title">{{node.activeTool}}</span>
      <span class="a-icon-btn" *ngFor="let tool of getToolSets(node)" (mouseenter)="onmouseenter(node,tool.label)"
        (mouseleave)="onmouseleave(node,tool.label)" (click)="tool.onClick($event,node)"><i
          class="{{tool.icon}}"></i></span>
    </span>
  </ng-template>
</p-tree>